module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ClanInfoPanel/images/elo-icon-8.a1c48724.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ClanInfoPanel/images/elo-icon-8.png
// module id = 3266
// module chunks = 11